import React, { useState, useEffect } from 'react';
import { Menu, X, Dumbbell } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const navigateToPage = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'Services', id: 'services', type: 'section' },
    { label: 'Conditions', path: '/conditions', type: 'page' },
    { label: 'Team', id: 'team', type: 'section' },
    { label: 'Testimonials', id: 'testimonials', type: 'section' },
    { label: 'Pricing', path: '/pricing', type: 'page' },
    { label: 'Contact', path: '/contact', type: 'page' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <button 
            onClick={() => navigateToPage('/')}
            className="flex items-center gap-3 group"
          >
            <img 
              src="/images/logo.png"
              alt="MSK and Sports Physio Logo"
              width="48"
              height="48"
              className="h-12 w-12 object-contain transform group-hover:scale-105 transition-transform duration-200"
            />
            <div className="flex flex-col items-start">
              <span className="text-xl font-bold text-gray-900 leading-tight">MSK and Sports Physio - Param Jumani</span>
            </div>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.label}
                onClick={() => link.type === 'section' ? scrollToSection(link.id) : navigateToPage(link.path)}
                className="text-gray-700 hover:text-[#2563eb] font-medium transition-colors duration-200 relative group"
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#06b6d4] group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
            <Button 
              onClick={() => navigateToPage('/contact')}
              className="bg-[#2563eb] hover:bg-[#1d4ed8] text-white px-6 py-2.5 rounded-lg font-medium shadow-lg shadow-[#2563eb]/30 hover:shadow-xl hover:shadow-[#2563eb]/40 transition-all duration-200"
            >
              Book Now
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-900" />
            ) : (
              <Menu className="w-6 h-6 text-gray-900" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => link.type === 'section' ? scrollToSection(link.id) : navigateToPage(link.path)}
                  className="text-left px-4 py-3 text-gray-700 hover:bg-[#eff6ff] hover:text-[#2563eb] rounded-lg font-medium transition-colors duration-200"
                >
                  {link.label}
                </button>
              ))}
              <Button 
                onClick={() => navigateToPage('/contact')}
                className="mt-2 bg-[#2563eb] hover:bg-[#1d4ed8] text-white w-full py-3 rounded-lg font-medium"
              >
                Book Now
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
